export const formatPhoneNumber = (phoneNumber?: string): string => {
  if (!phoneNumber) return '';

  if (!/^\d{0,10}$/.test(phoneNumber))
    throw new Error('Phone number must be a 10-digit numeric string');

  const { length } = phoneNumber;

  const areaCode = phoneNumber.slice(0, 3);
  const prefix = phoneNumber.slice(3, 6);
  const lineNumber = phoneNumber.slice(6, 10);

  if (length > 6) return `(${areaCode})${prefix}-${lineNumber}`;

  if (length > 3) return `(${areaCode})${prefix}`;

  if (length > 0) return `(${areaCode}`;

  return '';
};
